import yousersjs from '@yola/yousersjs';
import { errors } from '@yola/ws-sdk';
import actions from '../actions';
import actionTypes from '../constants/action-types';
import { snakeCaseObjectToCamelCase } from '../../../utils/convert-case';

const userFeaturesLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_FEATURES: {
      yousersjs
        .features()
        .get()
        .then(({ body }) => {
          const data = snakeCaseObjectToCamelCase(body);
          store.dispatch(actions.setUserFeatures(data));

          next(action);
        })
        .catch((error) => {
          errors.operations.catchError(error);

          next(action);
        });

      break;
    }

    default:
      next(action);
  }
};

export default userFeaturesLoader;
